<script>
import resources from './resources'
import '@desislavsd/vue-select/dist/vue-select.css'

export default {
  name: 'unit-form',
  mixins: [resources]
}
</script>

<template lang="pug">
  section.content
    .container-fluid
      .block-header
        .row
          .col-lg-5.col-md-5.col-sm-12
            h2 Residem no Local
            ul.breadcrumb.padding-0
              li.breadcrumb-item
                a(href='index.html')
                  i.zmdi.zmdi-home
              li.breadcrumb-item
                a(href='javascript:void(0);') Residem no Local
              li.breadcrumb-item.active Cadastro
          //-.col-lg-7.col-md-7.col-sm-12
            .input-group.m-b-0
              input.form-control(
                type='text',
                placeholder='Localizar Unidade',
                disabled
              )
              span.input-group-addon
                i.zmdi.zmdi-search


      .row.clearfix
        .col-lg-12
          .card
            .header
              ul.header-dropdown
                li.dropdown(:class="{'show': show}")
                  a.dropdown-toggle(@click.prevent="showActions(show)", href='javascript:void(0);')
                    i.zmdi.zmdi-more
                  ul.dropdown-menu.dropdown-menu-right(:class="{'show': show}")
                    li
                      router-link(:to="{name: 'tenant.livings.index'}") Listagem
                    li
                     router-link(:to="{name: 'tenant.livings.create'}") Cadastro
            .body
              h2.card-inside-title Dados da Unidade
              .row.clearfix
                .col-lg-6.col-md-6
                  .form-group
                    v-input(:status="$v.living.tower_id.$error ? 'error' : null")
                      f-select(
                        id="unit_id",
                        name="tower",
                        track-by="id",
                        label-by="number",
                        v-model="living.tower_id",
                        :options="dwellerTowers",
                        :searchable="true",
                        :multiple="false",
                         placeholder='Sua Torre',
                        @selected ="selectUnitsTower"
                        openDirection="bottom"
                      )

                .col-lg-6.col-md-6
                  .form-group
                    v-input(:status="$v.living.unit_id.$error ? 'error' : null")
                      f-select(
                        id="unit_id",
                        name="Unidade",
                        track-by="id",
                        placeholder="Sua Unidade"
                        label-by="number",
                        v-model="living.unit_id",
                        :options="dwellerUnits",
                        :searchable="true",
                        :multiple="false",
                        openDirection="bottom"
                      )
              h2.card-inside-title Dados do Morador
              .row.clearfix
                .col-lg-4.col-md-4
                  .form-group
                    v-input(:status="$v.living.people_name.$error ? 'error' : null")
                      input.form-control(
                        type='text',
                        placeholder='Nome do morador',
                        v-model="living.people_name"
                      )
                .col-lg-4.col-md-4(v-if="living.access")
                  .form-group
                    v-input(:status="$v.living.people_email.$error ? 'error' : null")
                      input.form-control(
                        type='text',
                        placeholder='Email do Morador',
                        v-model="living.people_email"
                      )
                .col-lg-4.col-md-4
                  .form-group
                    v-input(:status="$v.living.phone.$error ? 'error' : null")
                      the-mask.form-control(
                        :mask="['(##) ####-####','(##) #####-####']",
                        name='text',
                        type='text',
                        placeholder='(00) 9 0000-0000'
                        v-model="living.phone"
                        autocomplete="off"
                      )

                .col-lg-4.col-md-12
                  .form-group
                    .checkbox
                        input(
                          type='checkbox'
                          v-model="living.status"
                        )
                        label(for='terms', @click.prevent="livingStatus(!(!living.status))")
                          | Ativar Morador
                    .checkbox
                      input(
                        type='checkbox'
                        v-model="living.access"
                      )
                      label(for='terms', @click.prevent="livingStatusAccesss(!(!living.access))")
                        | Permitir acesso ao sistema.
                .col-md-12
                    button.btn.btn-raised.btn-primary.btn-round.waves-effect(
                      type='button',
                      @click.prevent="doSave()",
                    ) Salvar

</template>
<style scoped>
.color-red {
  color: #f96332;
}
</style>



// WEBPACK FOOTER //
// src/app/tenant/livings/form/form.vue